import React from 'react';

export interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
  dataTestId?: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
  className?: string;
  tabClassName?: string;
  activeTabClassName?: string;
  inactiveTabClassName?: string;
  sticky?: boolean;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTabId,
  onTabChange,
  className = '',
  tabClassName = '',
  activeTabClassName = '',
  inactiveTabClassName = '',
  sticky = false,
}) => {
  const defaultActiveClasses = 'border-orange-500 text-orange-600';
  const defaultInactiveClasses =
    'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600';

  return (
    <div className={className}>
      {/* Tab Navigation */}
      <div
        className={`border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900 ${sticky ? 'sticky top-0 z-10' : ''}`}
      >
        <div className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              data-testid={tab.dataTestId}
              className={`border-b-2 px-4 py-2 text-sm font-medium transition-colors ${tabClassName} ${
                activeTabId === tab.id
                  ? activeTabClassName || defaultActiveClasses
                  : inactiveTabClassName || defaultInactiveClasses
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex min-h-0 flex-1 flex-col">
        {tabs.find((tab) => tab.id === activeTabId)?.content}
      </div>
    </div>
  );
};
